import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocV1CorrectText extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_CORRECT_TEXT)
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span id="correctv1_endpoint">
                    <span className='heading-1'>Correct Text</span>
                </span>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V1_CORRECT_TEXT}
                </code>
                <div className="description">
                    The correct-text endpoint attempts to fix common text issues including capitalization, punctuation, etc.
                    This is particularly helpful for social media, chat, automatic speech recognition or 
                    closed caption text where the text may be all lowercase or all uppercase.<br/>
                </div>

                <h4 className="heading-2" id="correctv1_request">Request</h4>
                <div className="description">
                    The correct-text request is a JSON object that contains the request parameters.<br/>
                </div>

                <h4 className="heading-3" id="correctv1_request_object">Request object</h4>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">The UTF-8 encoded text content to be corrected.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints"></td>
                    </tr>
                    <tr>
                        <td className="attribute">languageCode</td>
                        <td className="meaning">Language in which the text should must be analyzed.<br/>
                            Specified as an ISO 639-1 code.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Default: "en"<br/>
                            <br/>
                            Only english available at this time.    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">textCorrections</td>
                        <td className="meaning">An array of supported text corrections.
                        </td>
                        <td className="type">[String]</td>
                        <td className="constraints">See supported <a href="#correctv1_text_corrections">text corrections</a>.</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="correctv1_text_corrections">Text Corrections</h4>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">case</td>
                        <td className="meaning">Fix capitalization issues in the request text.</td>
                    </tr>
                    <tr>
                        <td className="attribute">punctuation</td>
                        <td className="meaning">Fix punctuation issues in the request text.</td>
                    </tr>
                    <tr>
                        <td className="attribute">token</td>
                        <td className="meaning">Reviews each token in the request text to determine if, due to an error in previous processing, 
                            it is the result of dropping white space separating two consecutive words. If so, splits the token into 
                            the two component words.
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2" id="correctv1_response">Response</h4>
                <div className="description">
                    The correct-text response is a JSON object that contains the corrected text.
                </div>

                <h4 className="heading-3" id="correctv1_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">correctedText</td>
                        <td className="meaning">The UTF-8 encoded text that has been corrected.
                        </td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <div className="example-content host">
                    <pre>
                        POST {urlHandler.API_ENDPOINT_V1_CORRECT_TEXT}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                    </pre>
                    <pre>{JSON.stringify(examples.EXAMPLE_REQUEST_CORRECT_TEXT, null, 3)}</pre>
                </div>
                <HttpRunner example="correct1" 
                    query="correct-text" 
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_CORRECT_TEXT) : null}
                />

            </div>
        );
    }
}

export default DocV1CorrectText;